// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload button {
  margin-left: 5px;
}

.section-title {
  margin-bottom: 50px;
}

.file-input-btn {
  margin-bottom: 0;
}

.upload .previews {
  margin: 0 10px;
}

.upload .localsubmit {
  margin: 0 10px;
}

.example-headers-align .mat-expansion-panel-header-title,
.example-headers-align .mat-expansion-panel-header-description {
  flex-basis: 0;
}

.example-headers-align .mat-expansion-panel-header-description {
  justify-content: space-between;
  align-items: center;
}

mat-form-field {
  margin-right: 12px;
}

.btn {
  margin-right: 8px;
}

.mat-action-row {
  border-top-style: none;
  padding: 4px 4px 4px 4px;
}

.rt-full-width {
  width: 70%;
}

ol {
  columns: 1;
  -webkit-columns: 1;
  -moz-columns: 1;
}

li {
  margin-top: 5px;
  margin-left: 10px;
  padding: 2px;
}

.fileupload-drop-zone {
  border: 1px solid green;
  height: 50px;
}

.divLabel {
  float: left;
  border-radius: 10%;
  height: 32px;
  color: white;
}

.table-container {
  overflow-x: auto;
  max-width: 100%;
  margin-bottom: 10px;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  white-space: nowrap; /* Prevent text wrapping */
  overflow: hidden; /* Hide overflowing content */
  text-overflow: ellipsis; /* Show ellipsis for truncated text */
}

th, tr, td :hover {
  cursor: pointer;
}

table .header-row td {
  background-color: #3b5998; /* Light grey background for headers of table 1 */
  font-weight: bold;
}

.selected-cell {
  background-color: rgb(108, 184, 212); /* Or any other color you prefer */
}

.table-striped th,
.table-striped td:first-child {
  position: sticky;
  left: 0;
  background-color: #efeff4;
  z-index: 1;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/pages/doc-upload/doc-upload.component.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;AAAJ;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAIE;EACE,cAAA;AADJ;;AAME;EACE,cAAA;AAHJ;;AAOA;;EAEE,aAAA;AAJF;;AAOA;EACE,8BAAA;EACA,mBAAA;AAJF;;AAOA;EACE,kBAAA;AAJF;;AAOA;EACE,iBAAA;AAJF;;AAMA;EACE,sBAAA;EACA,wBAAA;AAHF;;AAKA;EACE,UAAA;AAFF;;AAIA;EACE,UAAA;EACA,kBAAA;EACA,eAAA;AADF;;AAGA;EACE,eAAA;EACA,iBAAA;EACA,YAAA;AAAF;;AAEA;EACE,uBAAA;EACA,YAAA;AACF;;AACA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AAEF;;AACA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;AAEF;;AAQA;EACE,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA,EAAA,0BAAA;EACA,gBAAA,EAAA,6BAAA;EACA,uBAAA,EAAA,qCAAA;AALF;;AAQA;EACE,eAAA;AALF;;AAQA;EACE,yBAAA,EAAA,iDAAA;EACA,iBAAA;AALF;;AAQA;EACE,oCAAA,EAAA,kCAAA;AALF;;AAQA;;EAEI,gBAAA;EACA,OAAA;EACA,yBAAA;EACA,UAAA;AALJ;AACA,o7HAAo7H","sourcesContent":[".upload {\r\n  button {\r\n    margin-left: 5px;\r\n  }\r\n}\r\n.section-title {\r\n  margin-bottom: 50px\r\n}\r\n\r\n.file-input-btn {\r\n  margin-bottom: 0\r\n}\r\n\r\n.upload {\r\n  .previews {\r\n    margin: 0 10px\r\n  }\r\n}\r\n\r\n.upload {\r\n  .localsubmit {\r\n    margin: 0 10px\r\n  }\r\n}\r\n\r\n.example-headers-align .mat-expansion-panel-header-title,\r\n.example-headers-align .mat-expansion-panel-header-description {\r\n  flex-basis: 0;\r\n}\r\n\r\n.example-headers-align .mat-expansion-panel-header-description {\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\nmat-form-field {\r\n  margin-right: 12px;\r\n}\r\n\r\n.btn {\r\n  margin-right: 8px;\r\n}\r\n.mat-action-row {\r\n  border-top-style:none;\r\n  padding: 4px 4px 4px 4px;\r\n}\r\n.rt-full-width {\r\n  width: 70%;\r\n}\r\nol {\r\n  columns: 1;\r\n  -webkit-columns: 1;\r\n  -moz-columns: 1;\r\n}\r\nli{\r\n  margin-top: 5px;\r\n  margin-left: 10px;\r\n  padding: 2px;\r\n}\r\n.fileupload-drop-zone{\r\n  border: 1px solid green;\r\n  height: 50px;\r\n}\r\n.divLabel{\r\n  float: left;\r\n  border-radius: 10%;\r\n  height: 32px;\r\n  color: white;\r\n}\r\n\r\n.table-container {\r\n  overflow-x: auto; \r\n  max-width: 100%; \r\n  margin-bottom: 10px;\r\n \r\n}\r\n\r\n// table{\r\n//   height: 300px;\r\n//   display: block;\r\n//   overflow-y: auto;\r\n// }\r\n\r\nth, td {\r\n  border: 1px solid #ddd;\r\n  padding: 8px;\r\n  text-align: left;\r\n  white-space: nowrap; /* Prevent text wrapping */\r\n  overflow:hidden; /* Hide overflowing content */\r\n  text-overflow: ellipsis; /* Show ellipsis for truncated text */\r\n}\r\n\r\nth,tr,td :hover {\r\n  cursor: pointer;\r\n\r\n}\r\ntable .header-row td {\r\n  background-color:#3b5998; /* Light grey background for headers of table 1 */\r\n  font-weight: bold;\r\n}\r\n\r\n.selected-cell {\r\n  background-color: rgb(108, 184, 212); /* Or any other color you prefer */\r\n}\r\n\r\n.table-striped th,\r\n.table-striped td:first-child {\r\n    position: sticky;\r\n    left: 0;\r\n    background-color: #efeff4;\r\n    z-index: 1;\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
